<!--
   V 0.1.0 - 2024-10-29
      - Copied from VehicleSelect.vue

-->

<template>
  <v-card height="100%">
    <!-- Error notes -->
    <div>
      <v-alert v-if="error" text prominent type="error" icon="mdi-cloud-alert">
        <v-row align="center" no-gutters>
          <v-col class="grow">
            <div v-text="errorMessage"></div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="shrink">
            <v-btn color="error" outlined v-on:click="error = false">
              <v-icon dark> mdi-close </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </div>

    <v-row>
      <!--
         No hint configure for this text
         hint= "Name, Surname, Company Name"
       -->

      <v-col cols="12" sm="12" md="12">
        <v-text-field class="px-6 pr-6"
                      append-outer-icon="mdi-refresh"
                      @click:row="onRowClicked"
                      @click:append-outer="getRapVehicle()"
                      v-model="searchString"
                      label="Search: Driver, Registration, Make"
                      prepend-icon="mdi-magnify"
                      @keydown.enter="getRapVehicle()"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col >
        <v-container>
          <v-row justify="center">
            <h4 class="text-h6 pa-4">
              <v-icon :size="iconSize">{{ iconMap[page] }}</v-icon>
              {{ description }}
            </h4>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <!--

   V 0.1.0 - Datatable 2023-02-22
       - Changed table to not be paging, as this is for a cellphone, so we want user to scroll
         through vehicles they are look for, Changed:
           :items-per-page="-1"
           :hide-default-footer="true"
           show-select
           :footer-props="footerProps"

       - Added
          - mobile-breakpoint="0"

       - removed
          class="elevation-2"

  -->

    <v-data-table mobile-breakpoint="0"
                  @click:row="onRowClicked"
                  v-model="selected"
                  :single-select="true"
                  id="dataGrid2"
                  :search="searchString"
                  item-key="ID"
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                  show-expand
                  :items-per-page="-1"
                  :headers="headers"
                  :items="filteredItems"
                  :loading="loading"
                  :hide-default-footer="true">
      <!--
     Example template for customn column
     v-swipe:left="() => activateMethod(item)"

  -->

      <template v-slot:item.UserVehicleMake="{ item }">
        {{ item.UserVehicleMake }}
        {{ item.UserVehicleModel }}
      </template>

      <!--
           Changed car bettery to internal battery
      -->
      <!--
            <template v-slot:item.CarBattery="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-chip :color="getBattery(item.CarBattery)" dark>
                      {{
                        item.CarBattery.toFixed(1)
                          .toString()
                          .padStart(4, "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;")
                      }}
                    </v-chip>
                  </span>
                </template>
                <span>Last recorded battery level</span>
              </v-tooltip>
            </template>
       -->

      <template v-slot:item.InternalBattery="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-chip :color="getInternalBattery(item.InternalBattery)" dark>
                {{
                  item.InternalBattery.toFixed(1)
                    .toString()
                    .padStart(4, "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;")
                }}
              </v-chip>
            </span>
          </template>
          <span>Mole Last recorded battery level</span>
        </v-tooltip>
      </template>

      <template v-slot:item.IgnitionStatus="{ item }" :value="item.LastUpdate">
        <v-chip :color="getMoleColor(item)" :value="item.LastUpdate" dark>
          <div v-if="getElapsed(item.LastUpdate) >= maxElapsed"></div>
          &nbsp;&nbsp;
        </v-chip>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="13">
          <v-container class="grey lighten-5">
            <v-row class="mb-6" no-gutters>
              <v-col cols="12" sm="6" md="4" />

              <SubTableDetail :row-item="item"
                              :client-table-sub-headers="subheaders" />

              <v-col />
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>

    <div>
      <v-alert type="error" v-model="error" dismissible>
        <div v-text="errorMessage"></div>
      </v-alert>

      <v-alert type="error" v-model="error" dismissible>
        <div v-text="errorDebug"></div>
      </v-alert>
    </div>
  </v-card>
</template>

<script>
/* eslint import/no-absolute-path:off */

import { differenceInHours } from 'date-fns'
import SubTableDetail from '/src/lib/v1/tables/SubTableDetail.vue'
import { moleSubTableHeaders } from './MoleSubTableHeaders'
import { moleTableHeaders } from './MoleTableHeaders'

export default {
  name: 'searchRap.Mole',

  components: {
    SubTableDetail
  },

  data () {
    return {
      icon: 'mole-select', // This can be dynamically set
      iconSize: 36, // Size of the icon
      iconMap: {
        'map-follow': 'fa fa-car',
        'calendar-trips-select': 'mdi-calendar-expand-horizontal',
        'day-select': 'mdi-queue-first-in-last-out',
        'mole-select': 'fas fa-car-side'
      },

      // 2024-09-16
      //  - Add the ability to eliminate certain models in the, liek if we dont want to see the moles.
      ignoreFilter: 0,
      showFilter: 0,
      // we need to display on this page somewhere or how, perhaps where it apperrats what this is for,
      // what page where we selecting for was it for the Day Triper, the Calendear
      description: '',

      // 2023-03-20
      //  - page: added so that vehicle select coudl be used for multiple functions
      //
      page: '',
      // 2023-03-06
      // sortBy: "chip.value",
      // sortDesc: false,
      ///
      selected: [],
      searchString: '',
      maxElapsed: 48,
      ///
      /// ------------------ GRID ---------------------------------------
      ///
      expanded: [],
      singleExpand: true,
      itemsList: [],
      loading: false,

      error: false,
      errorMessage: '. . .',
      errorDebug: '',
      headers: this.showCols(
        [
          // "actions",
          'IgnitionStatus',
          'InternalBattery',
          'RegNumber',
          'LastUpdate',
          'UserVehicleMake',
          'DriverName',
          'UserVehicleModel'
          // 'CarBattery'
        ],
        moleTableHeaders
      ),

      subheaders: this.showCols(
        [ // "actions",
          'RegNumber',
          'DriverName',
          'CarBattery',
          'LastUpdate',
          'UserVehicleMake',
          'UserVehicleModel',
          'ChassisNumber',
          'Colour',
          'UnitID',
          'Description',
          'InceptionDate',
          'DriverName',
          'InternalBattery',
          'TenantCode',
          'IgnitionStatus',
          'ClientID',
          'ID'
        ],
        moleSubTableHeaders
      ),

      options: {},
      itemsPerPage: 10
    }
  },

  created () {
    /**
     *  V 0.1.0 - 2024-10-23
     *     -
     */
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        if (this.$debug) {
          console.log('toParams:')
          console.log(toParams)
          console.log(previousParams)
        }
        this.page = this.$route.params.page

        if (this.$route.params.filter) {
          const result = parseInt(this.$route.params.filter)
          if (isNaN(result)) {
            this.showFilter = 0
            this.ignoreFilter = 0
          } else if (result > 0) {
            this.ignoreFilter = result
            this.showFilter = 0
          } else {
            this.showFilter = -result
            this.ignoreFilter = 0
          }
        }

        if (this.$store.state.controlView) {
          this.showFilter = 0
          this.ignoreFilter = 0
        }

        this.description = this.$route.params.description

        this.getRapVehicle()
      }
    )
  }, // created()

  computed: {
    filteredItems () {
      //
      // how do we decided at this point to have
      // also change the namne of what you are viewing
      //
      var itemList

      if (this.showFilter === 0 && this.ignoreFilter === 0) {
        itemList = this.itemsList
      } else if (this.ignoreFilter > 0) {
        itemList = this.itemsList.filter(
          (item) => item.UnitModel2ID !== this.ignoreFilter
        )
      } else {
        itemList = this.itemsList.filter(
          (item) => item.UnitModel2ID === this.showFilter
        )
      }

      return itemList
    }
  },

  watch: {
    options: {
      handler () {
        this.getRapVehicle()
      },
      deep: true
    }
  },
  mounted () {
    this.page = this.$route.params.page

    if (this.$route.params.filter) {
      const result = parseInt(this.$route.params.filter)
      if (isNaN(result)) {
        this.showFilter = 0
        this.ignoreFilter = 0
      } else if (result > 0) {
        this.ignoreFilter = result
        this.showFilter = 0
      } else {
        this.showFilter = -result
        this.ignoreFilter = 0
      }
    }

    if (this.$store.state.controlView) {
      this.showFilter = 0
      this.ignoreFilter = 0
    }

    this.description = this.$route.params.description

    if (this.$debug) {
      console.log(`page:  ${this.page}`)
    }

    this.getRapVehicle()
  },

  methods: {
    onRowClicked (item) {
      // Handle row click event
      console.log(item.RegNumber)

      const route = `/${this.page}/${item.UnitID}/${item.RegNumber
        }/${item.DriverName.replace('/', '-')}/${item.ID}`

      if (this.$debug) {
        console.log(`route: ${route}`)
      }

      this.$router.push(route)
    },

    swipe (direction) {
      console.log(direction)
    },
    /*
       *
       *     V 0.1.0 - 2023-02-22
       *       Imported from: TripExtractedTable.vue
       *
       */
    showCols (visibleHdrs, allHdrs) {
      const visibleCols = []

      visibleHdrs.forEach((hdr) => {
        const searchCol = allHdrs.find((col) => col.value === hdr)
        if (typeof searchCol !== 'undefined') {
          visibleCols.push(searchCol)
        }
      })
      return visibleCols
    },

    /**
     *  v 0.1.0 - 2024-10-29
     */
    getInternalBattery (InternalBattery) {
      if (InternalBattery >= 5) {
        return 'green'
      }
      return 'red'
    },

    /**
      *   V 0.1.0 - 2022-10-03
      *
      */
    getBattery (CarBattery) {
      if (CarBattery >= 11) {
        return 'green'
      }
      return 'red'
    },

    /**
       *   V 0.1.0 - 2022-10-03
       *
       */
    getElapsedMax (lastUpdate) {
      const lastTime = new Date(lastUpdate)
      const currTime = new Date()
      const elapsed = differenceInHours(currTime, lastTime)
      if (elapsed > this.maxElapsed) {
        return this.maxElapsed
      }

      return elapsed
    },

    /**
       *   V 0.1.0 - 2022-10-03
       *
       */
    getElapsed (lastUpdate) {
      const lastTime = new Date(lastUpdate)
      const currTime = new Date()
      const elapsed = differenceInHours(currTime, lastTime)

      return elapsed
    },

    /**
       *   V 0.2.0 - 2024-10-29
       *      - Changed this to not be ignition related
       *
       *   V 0.1.0 - 2022-10-03
       *
       */
    getMoleColor (item) {
      const elapsed = this.getElapsedMax(item.LastUpdate)

      const elapsedInception = this.getElapsed(item.InceptionDate)
      // console.log(' date:' + item.InceptionDate)
      // console.log(' incep:' + elapsedInception)
      // ----------------------------------------------
      // this is 33 months in hours
      // ----------------------------------------------
      if (elapsedInception >= 24192) {
        return 'red'
      }
      else if (elapsed >= this.maxElapsed) {
        return 'orange'
      }

      return 'blue'
    },

    /**
       *
       *   Form actions:
       *
       */
    refresh_click () {
      this.userSelected = false
      this.clientSelected = false

      if (this.$debug) {
        console.log('refresh_click')
      }
      this.getRapVehicle()
    },

    /*
       *  Used to allow easy switch beteween
       */
    getRapVehicle () {
      this.getRapVehicleRemote()
      // this.getLocalData();
    },

    /**
       *
       *  V 0.1
       *     -   This function is used for testing the display without the need for the
       *         web api running
       *
       */
    getLocalData () {
      let url = ''
      url += '../api/vehicle-list.json'

      if (this.$debug) {
        console.log(url)
      }

      this.loading = true
      this.$axios
        .get(url)
        .then((res) => {
          this.loading = false

          if (this.$debug) {
            console.log('axios return:')
            console.log(res)
          }

          this.itemsList = res.data
        })
        .catch((error) => {
          this.loading = false
          this.errorMessage = 'Unable to retrieve local test data .\r\n'
          this.errorMessage += error
          this.error = true

          console.log(error)
        })
    },

    /*
       *
       *   V 0.1  2022-03-30
       *      -
       *
       */
    getRapVehicleRemote () {
      this.loading = true

      let url = this.$baseUrl
      url += '/api/v2/vehicle'

      if (this.$debug) {
        console.log(url)
      }

      this.error = false
      this.$axiosCache
        .get(url)
        .then((data) => {
          this.loading = false

          if (this.$debug) {
            console.log(data)
          }

          this.itemsList = data.data
          this.totalAlarms = this.itemsList.length
        })
        .catch((err) => {
          this.loading = false
          this.error = true

          const errObj = err.response

          if (typeof errObj === 'undefined') {
            this.errorMessage = err.message
            this.errorDebug = err.stack
          } else {
            console.log(errObj)
            console.log(errObj.request)

            let debugMessage = ''
            debugMessage = ' Debug Error: \r\n'
            debugMessage += `      url:  ${errObj.config.url} \r\n`
            debugMessage += `     data:  ${errObj.config.data} \r\n`
            debugMessage += errObj.data

            this.errorDebug = debugMessage

            this.error = true
            this.errorMessage = ''

            console.log(err.response.config.url)
          }
        })
    }
  }
}
</script>
<style scoped>
  #dataGrid3 {
    /*   height: calc(100vh - 64px -34);*/
    display: grid;
    gap: 10px;
  }
</style>
